import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { EmptyStateImages, Heading, Text, TextButton } from '../../../../../components/common';
import { ExternalSourcesConfigs } from '../../../constants/Sources';
import { IOuter } from './EmptyState.types';

import styles from './EmptyState.scss';

export const EmptyState: FC<IOuter> = ({
  isSearch,
  searchQuery,
  isRoot,
  isWixSitesRoot,
  source,
  areNotAllMediaTypesSelected,
  clearAllExtendedFilters,
}) => {
  const config = ExternalSourcesConfigs[source];

  const emptyFolderWithFilters = (
    <FormattedMessage
      id="empty-state.no-media-types-subtitle-new"
      values={{
        clearFilters: (
          <TextButton size="small" as="a" onClick={clearAllExtendedFilters}>
            <FormattedMessage id="empty-state.no-media-types-subtitle.clear-filters" />
          </TextButton>
        ),
      }}
    />
  );

  const rootMessage = areNotAllMediaTypesSelected ? emptyFolderWithFilters : config.emptyRootFolderMessage;
  const folderMessage = areNotAllMediaTypesSelected ? emptyFolderWithFilters : config.emptyFolderMessage;

  const getTitle = () => {
    if (isSearch) {
      const key = 'empty.state.board.search-no-media-title';

      return <FormattedMessage id={key} />;
    }

    if (isRoot) {
      return config.emptyRootFolderTitle;
    }

    if (isWixSitesRoot) {
      return <FormattedMessage id="files-importer.empty-root-folder.title.wix-sites-root" />;
    }

    return config.emptyFolderTitle;
  };

  const getMessage = () => {
    if (isSearch) {
      const key = 'empty.state.board.search-no-media-subtitle';
      return <FormattedMessage id={key} values={{ query: searchQuery }} />;
    }

    if (isRoot) {
      return rootMessage;
    }

    if (isWixSitesRoot) {
      return <FormattedMessage id="files-importer.empty-root-folder.message.wix-sites-root" />;
    }

    return folderMessage;
  };

  const title = getTitle();
  const message = getMessage();
  const newBrandingIcon = isSearch ? EmptyStateImages.Search : EmptyStateImages.SiteFiles;

  return (
    <div className={styles.wrapper}>
      <img src={newBrandingIcon} className={styles.newBrandingIcon} alt="" />

      <Heading size="medium" className={styles.text}>
        {title}
      </Heading>

      <Text tagName="div" weight="thin" size="small" secondary className={styles.text}>
        {message}
      </Text>
    </div>
  );
};
